import React from "react";

export default function MijnAanvragenTable({ aanvragen }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full table-auto border border-gray-300 mt-4">
  <thead className="bg-gray-100">
    <tr>
      <th className="p-3 text-left border-b">Onderdeel</th>
      <th className="p-3 text-left border-b">Beschrijving</th>
      <th className="p-3 text-left border-b">Status</th>
      <th className="p-3 text-left border-b">Opmerking</th>
    </tr>
  </thead>
  <tbody>
    {aanvragen.map((a) => (
      <tr key={a.Id} className="hover:bg-gray-50">
        <td className="p-3 border-b">{a.Onderdeel}</td>
        <td className="p-3 border-b">{a.Beschrijving}</td>
        <td className="p-3 border-b">{a.Status}</td>
        <td className="p-3 border-b">{a.Opmerking}</td>
      </tr>
    ))}
  </tbody>
</table>
    </div>
  );
}
